import { defineComponent as V, ref as y, computed as o, openBlock as I, createElementBlock as w, createVNode as n, unref as r, mergeProps as A } from "vue";
import { RevButtonIcon as g } from "@ds/components/ButtonIcon";
import { RevInputText as k } from "@ds/components/InputText";
import B from "../../icons/generated/IconEyeClosed.vue2.js";
import L from "../../icons/generated/IconEyeOpen.vue2.js";
import { tw as q } from "../../utils/tailwind.js";
const x = {
  class: "relative",
  "data-test": "input-password"
}, D = /* @__PURE__ */ V({
  inheritAttrs: !1,
  __name: "InputPassword",
  props: {
    hideAriaLabel: {},
    showAriaLabel: {},
    description: { default: "" },
    error: { default: void 0 },
    id: {},
    label: {},
    modelValue: {},
    disabled: { type: Boolean },
    required: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "input", "invalid", "valid"],
  setup(e, { emit: d }) {
    const i = e, l = d, a = y(!0), s = () => {
      a.value = !a.value;
    }, u = o(() => a.value ? L : B), c = o(() => a.value ? "password" : "text"), m = o(() => a.value ? i.showAriaLabel : i.hideAriaLabel), p = q`text-clip pr-44`, v = (t) => {
      l("update:modelValue", t);
    }, b = (t) => {
      l("input", t);
    }, f = (t) => {
      l("invalid", t);
    }, h = () => {
      l("valid");
    };
    return (t, C) => (I(), w("div", x, [
      n(r(k), A({ id: e.id }, t.$attrs, {
        description: e.description,
        disabled: e.disabled,
        error: e.error,
        "has-clear-button": !1,
        "input-class": p,
        label: e.label,
        "model-value": e.modelValue,
        required: e.required,
        type: c.value,
        onInput: b,
        onInvalid: f,
        "onUpdate:modelValue": v,
        onValid: h
      }), null, 16, ["id", "description", "disabled", "error", "label", "model-value", "required", "type"]),
      n(r(g), {
        "aria-label": m.value,
        class: "absolute inset-y-4 right-4 cursor-pointer",
        "data-test": "reveal-button",
        icon: u.value,
        type: "button",
        variant: "ghost",
        onClick: s
      }, null, 8, ["aria-label", "icon"])
    ]));
  }
});
export {
  D as default
};
